import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { LimitTypeEnum } from 'src/model/limit'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import { selectUserLimits } from 'src/reducers/user-limits/selector'

export const isCourseLimitReached = userLimits => {
  const courseLimit = userLimits?.find(
    x => x.limit.type === LimitTypeEnum.CourseCreation,
  )
  if (!courseLimit) return false

  const { count } = courseLimit
  const { upperLimit } = courseLimit.limit
  return upperLimit !== -1 && count >= upperLimit
}

/**
 * Starts the "create course" flow, or opens the limit modal when the plan's
 * course limit is reached. Render `LimitReachedModal` with `limitModalOpen`.
 */
const useCourseCreation = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const userLimits = useSelector(selectUserLimits)
  const [limitModalOpen, setLimitModalOpen] = useState(false)

  useEffect(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  const startCourseCreation = useCallback(
    collectionId => {
      if (isCourseLimitReached(userLimits)) {
        setLimitModalOpen(true)
        return false
      }
      history.push(`/create-course-selection?collectionId=${collectionId}`)
      return true
    },
    [history, userLimits],
  )

  const closeLimitModal = useCallback(() => setLimitModalOpen(false), [])

  return { startCourseCreation, limitModalOpen, closeLimitModal }
}

export default useCourseCreation
